import React, { Suspense } from 'react';

import HtmlWrapper from '../html-wrapper/html-wrapper';

const MunicipalityListWrapper = React.lazy(() => import('./municipality-list'));

export const MUNICIPALITY_LIST_TAG = 'ld-municipality-list-widget';

const DynamicMunicipalityList: React.FC = ({ children }) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MunicipalityListWrapper>{children}</MunicipalityListWrapper>
  </Suspense>
);

export default DynamicMunicipalityList;
